import axios from 'axios'

class Request {
  // axios 实例
  instance
  // 基础配置，url和超时时间
  baseConfig = {
    baseURL: 'https://api.askstarry.com',
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 50000
    // withCredentials: true
  }

  constructor(config) {
    // 使用axios.create创建axios实例
    this.instance = axios.create(Object.assign(this.baseConfig, config))
    // 请求拦截器
    this.instance.interceptors.request.use(
      (config) => {
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )
    // 响应拦截器
    this.instance.interceptors.response.use(
      (response) => {
        return response.data
      },
      (error) => {
        if (error && error.response) {
          const status = error.response.status
          switch (status) {
            case 400:
              console.log('请求错误')
              break
            case 401:
              console.log('未授权，请重新登录')
              break
            case 403:
              console.log('拒绝访问')
              break
            case 404:
              console.log('请求错误，未找到相应的资源')
              break
            case 408:
              console.log('请求超时')
              break
            case 500:
              console.log('服务器内部错误')
              break
            case 501:
              console.log('网络未实现')
              break
            case 502:
              console.log('网络错误')
              break
            case 503:
              console.log('服务不可用')
              break
            case 504:
              console.log('网络超时')
              break
            case 505:
              console.log('HTTP版本不支持该请求')
              break
            default:
              console.log('请求失败')
          }
        } else {
          if (JSON.stringify(error).includes('timeout')) {
            console.log('服务器响应超时，请刷新页面')
          } else {
            console.log('连接服务器失败')
          }
        }
        return Promise.reject(error)
      }
    )
  }

  // 定义请求方法
  request(config) {
    return this.instance.request(config)
  }

  get(url, config) {
    return this.instance.get(url, config)
  }

  post(url, data, config) {
    return this.instance.post(url, data, config)
  }

  put(url, data, config) {
    return this.instance.put(url, data, config)
  }

  delete(url, config) {
    return this.instance.delete(url, config)
  }
}

const http = new Request()
export default http
